<section class="section-pad market">
  <div class="container">

    <div class="market-head">
      <p class="eyebrow">Live market</p>
      <h2 class="section">What the market is <span class="em">actually doing.</span></h2>
      <p class="body" style="margin-top: 14px;">
        Real activity across the PlateX network. Searches, listings, dealer clicks, alerts firing &mdash; observed continuously, not curated.
      </p>
    </div>

    <div class="market-shell">

      <div class="market-feed">
        <div class="market-feed-head">
          <span class="market-feed-label"><span class="market-feed-pulse" aria-hidden="true"></span>Live activity</span>
          <span class="market-feed-count">across PlateX, last hour</span>
        </div>
        <ul class="market-feed-list">
          <li *ngFor="let item of feedItems">
            <span class="m-when">{{ item.when }}</span>
            <span class="m-text" [innerHTML]="item.text"></span>
          </li>
        </ul>
      </div>

      <div class="market-strip">

        <div class="market-strip-block">
          <p class="market-strip-label">What buyers are searching</p>
          <p class="market-strip-content">
            <span class="market-tag" *ngFor="let term of searchTerms">{{ term }}</span>
          </p>
          <p class="market-strip-meta">trending this week &middot; 13,114 searches across the last 30 days</p>
        </div>

        <div class="market-strip-block">
          <p class="market-strip-label">Newly listed</p>
          <p class="market-strip-content">
            <span class="plate sm" *ngFor="let plate of newlyListed">{{ plate }}</span>
          </p>
          <p class="market-strip-meta">181 listings in dealer review &middot; 334 in the DVLA pipeline</p>
        </div>

        <div class="market-strip-block market-strip-block--demand">
          <p class="market-strip-label">Observed demand signals</p>
          <ul class="demand-list">
            <li *ngFor="let signal of demandSignals">
              <span class="demand-num">{{ signal.num }}</span>
              <span class="demand-label">{{ signal.label }}</span>
            </li>
          </ul>
          <p class="market-strip-meta">indicators from observed search and listing data &middot; refreshed continuously</p>
        </div>

        <div class="market-strip-block">
          <p class="market-strip-label">Recently moved</p>
          <p class="market-strip-content">
            <span class="plate sm" *ngFor="let plate of recentlyMoved">{{ plate }}</span>
          </p>
          <p class="market-strip-meta">50 verified sales tracked across PlateX channels &middot; rolling 30d</p>
        </div>

      </div>

    </div>

    <p class="market-foot-note">
      Signals are observed continuously across the PlateX dealer network and search index &middot; never curated for display.
    </p>

  </div>
</section>
